module.exports = __webpack_public_path__ + "img/matthias-pro.cb5aaa4e.jpg";